import { render, staticRenderFns } from "./AssignmentInfo.vue?vue&type=template&id=64c4cd0e&scoped=true&"
import script from "./AssignmentInfo.vue?vue&type=script&lang=js&"
export * from "./AssignmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentInfo.vue?vue&type=style&index=0&id=64c4cd0e&prod&lang=css&"
import style1 from "./AssignmentInfo.vue?vue&type=style&index=1&id=64c4cd0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4cd0e",
  null
  
)

export default component.exports